<template>
  <div class="what-we-offer-component">
    <SectionTitle
      title="What We Offer"
      subtitle="CrowdFlik for Developers is an API and storage service for synchronized videos. We abstract you away from the complexities of managing, timing, and storing videos, so that you can focus on your users instead."
    />
    <br />
    <br />
    <div class="container">
      <div class="columns">
        <div
          class="column"
          v-for="feature in features"
          v-bind:key="feature.title"
        >
          <div class="card -card">
            <div
              class="card-image -card-image"
              v-observe-visibility="visibilityChanged"
            >
              <figure class="image is-square">
                <img v-bind:src="feature.imagePath" />
              </figure>
            </div>
            <div class="card-content has-text-centered">
              <p class="title is-size-4 is-size-5-touch">
                {{ feature.title }}
              </p>
              <hr class="-line-break" v-bind:class="feature.underlineColor" />
              <p class="subtitle is-size-6 has-text-grey-dark">
                {{ feature.description }}
              </p>
              <router-link to="/how-it-works">
                <button class="button is-primary -card-button">
                  Learn More
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "@/components/SectionTitle.vue";

export default {
  name: "WhatWeOfferComponent",
  components: {
    SectionTitle
  },
  data() {
    return {
      features: [
        {
          title: "Advanced Syncing",
          imagePath: require("@/assets/img/illustrations/05.png"),
          underlineColor: "has-background-success",
          description:
            "We reconcile device time and video time against the U.S. Military Clock, so that video times are consistent."
        },
        {
          title: "Easy Implementation",
          imagePath: require("@/assets/img/illustrations/06.png"),
          underlineColor: "has-background-warning",
          description:
            "Integrate with our REST API, with flexible storage options and the tools you need to build quickly."
        },
        {
          title: "Flexible Pricing",
          imagePath: require("@/assets/img/illustrations/07.png"),
          underlineColor: "has-background-danger",
          description:
            "Start for free, and scale as your app grows, with a variety of plans for projects of all shapes and sizes."
        }
      ]
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
      if (entry.isIntersecting === true) {
        console.log("animating..");
        this.$anime.timeline().add({
          targets: ".-card-image",
          scale: [1, 1.2, 1],
          duration: 700,
          easing: "easeInOutSine",
          delay: this.$anime.stagger(100, { start: 200 })
        });
      } else {
        console.log("not animating");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.-card {
  border-radius: 10px;
  padding-bottom: 30px;
}

.-card-image {
  padding-top: 20px;
  padding-left: 80px;
  padding-right: 80px;
  margin-bottom: -20px;
}

.-line-break {
  max-width: 120px;
  margin: 0 auto;
  height: 4px;
  border-radius: 10px;
  margin-bottom: 15px;
}
</style>
